import React from 'react';
import { Icon, Text } from '@common/components';
import { Spacing } from '@common/tokens';

export function ScheduleHomeUnit({
  unitName,
  roleAbbreviation,
}: {
  unitName: string;
  roleAbbreviation: string;
}) {
  // Drop the bullet when there's no unit, so we never render a leading "∙ Role".
  const label = unitName
    ? `${unitName} ∙ ${roleAbbreviation}`
    : roleAbbreviation;

  return (
    <div className="schedule-home-unit">
      <span className="schedule-home-unit-icon">
        <Icon icon="homeAlt" kind="light" color="midnightLighter" size="sm" />
      </span>
      <Text size="md" color="midnightLighter">
        {label}
      </Text>

      <style jsx>{`
        .schedule-home-unit-icon {
          line-height: 14px;
          vertical-align: text-top;
          margin-right: ${Spacing.xs}px;
        }
      `}</style>
    </div>
  );
}
